import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Globals } from "app/globals";
import { environment } from "environments/environment";

@Injectable({
  providedIn: "root",
})
export class StcikersService {
  constructor(private http: HttpClient, private globals: Globals) {}

  private readonly ROUTE = `${this.globals.apiUrl}/stickers`;

  get(opts?: { page?: number; limit?: number; search?: string }) {
    return this.http.get<[any[], number]>(`${this.ROUTE}`, {
      params: <any>opts,
    });
  }

  getById(id: number) {
    return this.http.get(`${this.ROUTE}/${id}`);
  }

  create(data: any) {
    return this.http.post(`${this.ROUTE}`, data);
  }

  update(id: number, data: any) {
    return this.http.patch(`${this.ROUTE}/${id}`, data);
  }

  delete(id: number) {
    return this.http.delete(`${this.ROUTE}/${id}`);
  }
}
